import axios from 'axios';
import { teClient } from '@/config';

export default {
  // 產生digest
  async getDigest(companyId, memberSourceId, body) {
    try {
      const payload = JSON.stringify(body);
      const res = await axios.post(`${teClient}/api/v1/dynamic/sso/post/api/v1/digest`, { companyId, memberSourceId, payload });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  // 驗證 accessToken
  async verifiyAccesstoken(headers) {
    try {
      const res = await axios.post(`${teClient}/api/v1/dynamic/sso/post/api/v1/accesstoken-decorder`, {}, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  },
  // 取得會員權杖
  async getAccessToken(body, headers) {
    try {
      const res = await axios.post(`${teClient}/api/v1/dynamic/sso/post/api/v1/accesstoken/code`, body, { headers });
      return res.data;
    } catch (err) {
      return err.response;
    }
  }
};
